import { render, staticRenderFns } from "./QxNewFormItem.vue?vue&type=template&id=a1d4c5e4&scoped=true&"
import script from "./QxNewFormItem.vue?vue&type=script&lang=js&"
export * from "./QxNewFormItem.vue?vue&type=script&lang=js&"
import style0 from "./QxNewFormItem.vue?vue&type=style&index=0&id=a1d4c5e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d4c5e4",
  null
  
)

export default component.exports